// extracted by mini-css-extract-plugin
export default {"order_countries_block":"styled_order_countries_block__X1RMF","order_countries_list":"styled_order_countries_list__4ywT+"};